import { render, staticRenderFns } from "./UserArticlesMsg.vue?vue&type=template&id=6a1a208a&scoped=true"
import script from "./UserArticlesMsg.vue?vue&type=script&lang=ts"
export * from "./UserArticlesMsg.vue?vue&type=script&lang=ts"
import style0 from "./UserArticlesMsg.vue?vue&type=style&index=0&id=6a1a208a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1a208a",
  null
  
)

export default component.exports